type MantineSize = 'sm' | 'md'

export const sizeSettings = {
  lg: 21,
  md: 18,
  sm: 20,
  xs: 24,
}

export const maxAppWidth = 1350

export const desktopBreakpoint = 'sm'
export type LayoutVariant = 'simple' | 'complex'

export const breakpoints = {
  sm: '768px',
  md: '992px',
  lg: '1200px',
  xl: '1400px',
}

export const panelWidth: Record<LayoutVariant, Partial<Record<MantineSize, number>>> = {
  simple: {
    sm: 50,
    md: 150,
  },
  complex: {
    sm: 100,
    md: 261,
  },
}
